<template>
  <div>
    <div class="t-card-list" v-if="select">
      <div v-for="(c,i) in innerValue" :key="'front'+i"
        class="t-card" @click="removeHand(i)"
        :class="{ 't-card-select': current === c }">
        <img :src="list | pick(c) | image(master) | coalesceImage" />
        <div class="t-card-front">{{ list | pick(c) | cardName(master) }}</div>
        <div class="num">{{ list | pick(c) | cardNum }}</div>
      </div>
      <div v-for="i in emptyCardNum" :key="'back'+i"
        class="t-card">
        <img :src="'./img/card/back.png'" />
      </div>
    </div>
    <b-container>
      <b-row>
        <b-col cols="6">
          <div class="t-card-list deck">
            <div v-for="c in list" :key="c.RID"
              class="t-card" @click="addHand(c.RID)"
              :class="{ 't-card-select': current === c.RID }">
              <img :src="master[c.key].image | coalesceImage" />
              <div class="t-card-front"
                :class="{ 't-card-unable-use': master[c.key].unableUse }">
                {{ c | cardName(master) }}
              </div>
              <div class="num">{{ c.num }}</div>
            </div>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="t-detail">
            <div v-if="current != null" class="t-info">
              <h4>
                {{ list | pick(current) | cardName(master) }}
                ({{ list | pick(current) | cardNum }})
              </h4>
              <div v-if="currentUnableUse"
                class="t-card-unable-use">
                このカードは現在いる世界では使えません！
              </div>
              <div v-html="currentMemo"></div>
              <div><slot :current="current" :index="currentIndex" /></div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  filters: {
    pick (cards, rid){
      return _.find(cards, (c)=>{ return c.RID == rid })
    },
    cardName (card, master) {
      return master[card.key].name
    },
    cardNum (card) {
      return card.num
    },
    image (card, master){
      return master[card.key].image
    },
    coalesceImage (image) {
      return image || './img/card/front.png'
    }
  },
  props: {
    value: {
      type:Array,
      default:()=>[],
    },
    select:{
      type:Boolean,
      default:false,
    },
    list: Array,
    master: Object
  },
  computed: {
    currentMemo () {
      return this.master[_.find(this.list,c=>c.RID==this.current).key].memo
    },
    currentUnableUse () {
      return this.master[_.find(this.list,c=>c.RID==this.current).key].unableUse
    },
    currentIndex () {
      return _.findIndex(this.innerValue,(o)=>{ return o == this.current })
    },
    emptyCardNum () {
      return this.innerValue.length>5 ?0 :(5-this.innerValue.length)      
    },
  },
  data () {
    return {
      innerValue:this.value,
      current: null
    }
  },
  methods: {
    addHand (c) {
      if(this.select && this.innerValue.length < 5
        && this.current === c && !this.currentUnableUse){
        this.innerValue.push(c)
        this.$emit('input', this.innerValue)
      }else{
        this.current = c
      }
    },
    removeHand (i) {
      if(this.current === this.innerValue[i]){
        this.innerValue.splice(i,1)
        this.$emit('input', this.innerValue)
        this.$emit('remove', i)
      }else{
        this.current = this.innerValue[i]
      }
    }
  },
  watch: {
    value (v) {
      this.innerValue = v
    }
  }
}
</script>

<style lang="scss" scoped>
.t-card-list {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  padding: 5px;
}
.t-card {
  position: relative;
  margin: 5px;
  width: 80px;
  height: 100px;
  cursor: pointer;

  .t-card-front {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    color: transparent;

    &:hover,
    &.t-card-select {
      background-color: rgba(0,0,0,0.3);
      color: #FFF;
    }

    &.t-card-unable-use {
      background-color: rgba(0,0,0,0.3);
    }
  }

  .num {
    position: absolute;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.7);
    color: #FFF;
  }
}
.t-detail {
  width: 100%;
  height: 100%;
  border: 1px solid #CCC;

  .t-info {
    padding: 10px;
  }

  .t-card-unable-use {
    color: red;
  }

  ::v-deep p {
    margin: 0;
  }
  ::v-deep .ql-size-large {
    font-size: 1.5em;
  }
  ::v-deep .ql-size-small {
    font-size: .75em;
  }
  ::v-deep .ql-size-huge {
    font-size: 2.5em;
  }
}
.deck {
  background-color: #999;
  height: 340px;
  overflow-y: scroll;
}
</style>
